import React from 'react';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import styles from './delete-icon.module.css';

export enum DeleteIconType {
  Small='small',
  Medium = 'medium',
  Large = 'large',
  Inherit = 'inherit',
}

type DeleteIconProps = {
  fontSize?: DeleteIconType | undefined;
  onClick?: (e: React.MouseEvent) => void;
  color?: string;
}

const DeleteIcon = (props: DeleteIconProps) => {
  const { onClick, fontSize = DeleteIconType.Small, color } = props;

  return (
    <HighlightOffIcon
      className={styles.button}
      onClick={onClick}
      fontSize={fontSize}
      style={color ? { color } : undefined}
    />
  );
};

export default DeleteIcon;
